export enum EInterventionStatus {
  Assignment = 'assignment',
  AwaitingQuote = 'awaiting_quote',
  AwaitingVisitDate = 'awaiting_visit_date',
  AwaitingWorkDates = 'awaiting_work_dates',
  Complaint = 'complaint',
  Lost = 'lost',
  QualitySurvey = 'quality_survey',
  QuoteReceived = 'quote_received',
  Success = 'success',
  Trashed = 'trashed',
  VisitPlanned = 'visit_planned',
  WorkOngoing = 'work_ongoing',
  WorkPlanned = 'work_planned',
}
